// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__ukj8W","containerItemsCenter":"Skeleton_containerItemsCenter__30oQd"};